import { TranslocoService } from '@ngneat/transloco';
import { StatusTagConfiguration } from '@platform-frontend/ui-tools';
import { AssetOwnershipStatus } from './asset-ownership-status';
import { ONE_TIME_PURCHASE_BOOKING_STATUS_TAG_CONFIGURATIONS } from './one-time-purchase-booking-status-tag-configurations';
import { SUBSCRIPTION_BOOKING_STATUS_TAG_CONFIGURATIONS } from './subscription-booking-status-tag-configurations';

export const ASSET_OWNERSHIP_STATUS_TAG_CONFIGURATIONS: (
  translocoService: TranslocoService,
  expiringTooltipDate?: string,
  tooltipClass?: string
) => StatusTagConfiguration<AssetOwnershipStatus>[] = (translocoService: TranslocoService, expiringTooltipDate?: string, tooltipClass?: string) => [
  ...SUBSCRIPTION_BOOKING_STATUS_TAG_CONFIGURATIONS(translocoService, expiringTooltipDate, tooltipClass),
  ...ONE_TIME_PURCHASE_BOOKING_STATUS_TAG_CONFIGURATIONS(translocoService)
];
